/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const totalStyle = {
  textAlign: "center",
  background: "#ddeff3",
  fontWeight: "bold",
  textAlign: "right",
  paddingRight: 20,
};

const titleStyle = {
  textAlign: "right",
  paddingRight: 20,
  background: "#ddeff3",
  fontWeight: "bold",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = {
  muc1: [
    {
      id: uuidV4(),
      value24a: "",
      value24b: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
      value29: "",
      value30: "",
    },
  ],
  muc2: [
    {
      id: uuidV4(),
      value24a: "",
      value24b: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
      value29: "",
      value30: "",
    },
  ],
  muc3: [
    {
      id: uuidV4(),
      value24a: "",
      value24b: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
      value29: "",
      value30: "",
    },
  ],
};

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value24a: "",
      value24b: "",
      value25: "",
      value26: "",
      value27: "",
      value28: "",
      value29: "",
      value30: "",
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">
        II. THÔNG TIN TỔ CHỨC, CÁ NHÂN NHẬN CHUYỂN NHƯỢNG VÔN GÓP, NHẬN CHUYỂN NHƯỢNG CHỨNG KHOÁNG
      </Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổ chức phát hành
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã số thuế tổ chức phát hành
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chứng khoán
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số lượng chứng khoán
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mệnh giá chứng khoán
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng giá trị tổ chức (hoặc lợi tức) được chia theo mệnh giá
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tổng giá trị theo giá số sách kế toán (hoặc theo giá thị trường)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Thuế phải nộp
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[23]</Td>
              <Td colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                [24]
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[25]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[26]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[27]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[28]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[29]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[30]</Td>
            </tr>

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                I
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                colSpan={5}
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold" }}
              >
                Chứng khoản trả thay tổ chức
              </Td>
              <Td style={titleStyle}>0</Td>
              <Td style={titleStyle}>0</Td>
              <Td style={titleStyle}>0</Td>
            </tr>
            {data?.muc1?.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc1"
                    name="value24a"
                    value={item.value24a}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc1"
                    name="value24b"
                    value={item.value24b}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc1"
                    name="value25"
                    value={item.value25}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc1"
                    name="value26"
                    value={item.value26}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc1"
                    name="value27"
                    value={item.value27}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc1"
                    name="value28"
                    value={item.value28}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc1"
                    name="value29"
                    value={item.value29}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc1"
                    name="value30"
                    value={item.value30}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                II
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                colSpan={5}
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold" }}
              >
                Chứng khoán thưởng cho cổ đông hiện hữu
              </Td>
              <Td style={titleStyle}>0</Td>
              <Td style={titleStyle}>0</Td>
              <Td style={titleStyle}>0</Td>
            </tr>
            {data?.muc2?.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc2"
                    name="value24a"
                    value={item.value24a}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc2"
                    name="value24b"
                    value={item.value24b}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc2"
                    name="value25"
                    value={item.value25}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc2"
                    name="value26"
                    value={item.value26}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc2"
                    name="value27"
                    value={item.value27}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc2"
                    name="value28"
                    value={item.value28}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc2"
                    name="value29"
                    value={item.value29}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc2"
                    name="value30"
                    value={item.value30}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                III
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc3")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                colSpan={5}
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: "bold" }}
              >
                Lợi tức ghi tăng vốn
              </Td>
              <Td style={titleStyle}>0</Td>
              <Td style={titleStyle}>0</Td>
              <Td style={titleStyle}>0</Td>
            </tr>
            {data?.muc3?.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc3", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc3"
                    name="value24a"
                    value={item.value24a}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc3"
                    name="value24b"
                    value={item.value24b}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc3"
                    name="value25"
                    value={item.value25}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc3"
                    name="value26"
                    value={item.value26}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc3"
                    name="value27"
                    value={item.value27}
                    onChange={handleChange}
                    id={item.id}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc3"
                    name="value28"
                    value={item.value28}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    rowType="muc3"
                    name="value29"
                    value={item.value29}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", minWidth: 200 }}>
                  <InputTable
                    rowType="muc3"
                    name="value30"
                    value={item.value30}
                    onChange={handleChange}
                    id={item.id}
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                colSpan={6}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: "bold" }}
              >
                Tổng cộng
              </Td>
              <Td style={totalStyle}>0</Td>
              <Td style={totalStyle}>0</Td>
              <Td style={totalStyle}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { id, onChange, type, name, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type || type === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type, rowType });
    }
    if (type && type === "text") {
      onChange({ id, value, name, type, rowType });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type && type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
